module.exports = __webpack_public_path__ + "static/img/lobg.5454e1f0.jpg";